import styled, { keyframes } from 'styled-components';
import { FlexWrap } from './FlexWrap';

type Props = {
  description?: string;
};

export const LoadingView = ({ description }: Props) => {
  return (
    <Container>
      <FlexWrap dir='column' alignItems='center'>
        {description && <Text>{description}</Text>}
        <LoadingSpinner />
      </FlexWrap>
    </Container>
  );
};

export default LoadingView;

const Spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinner = styled.div`
  animation: ${Spin} 600ms linear infinite;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  border: 6px solid #e9f0fe;
  border-top: 6px solid #246cf6;
`;

const Text = styled.p`
  margin-bottom: 20px;
  color: #246cf6;
  font-weight: bold;
  text-align: center;
  white-space: pre-wrap;
  line-height: 150%;
`;
